/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ScorecardDefinitionPatchFields } from './scorecardDefinitionPatchFields';
import type { SelectionRuleIn } from './selectionRuleIn';

export interface ScorecardDefinitionPatch {
  name?: string | null;
  fields?: ScorecardDefinitionPatchFields;
  selection_rule?: SelectionRuleIn | null;
  clear_selection_rule?: boolean;
  position?: number | null;
  archived?: boolean | null;
  is_default?: boolean | null;
  apply_library_update?: boolean;
}
